// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeSelectionToggleComponent {
  background-color: #e1e1e1;
  width: 120px;
  height: 40px;
  display: flex;
  padding: 2px;
  border-radius: 9px;
  justify-content: space-between;
  cursor: pointer;
}
.timeSelectionToggleComponent .selectItem {
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  height: 36px;
  width: 36px;
  padding: 6px 10.5px;
}
.timeSelectionToggleComponent .selectedItem {
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/screens/calendarNote/selectionToggle/selectionToggle.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AACJ;AACI;EAEI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAAR;AAEI;EACI,mBAAA;AAAR","sourcesContent":[".timeSelectionToggleComponent {\n    background-color: #e1e1e1;\n    width: 120px;\n    height: 40px;\n    display: flex;\n    padding: 2px;\n    border-radius: 9px;\n    justify-content: space-between;\n    cursor: pointer;\n\n    .selectItem {\n        // background: #ffffff;\n        border-radius: 8px;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        text-align: center;\n        color: #333333;\n        height: 36px;\n        width: 36px;\n        padding: 6px 10.5px;\n    }\n    .selectedItem {\n        background: #ffffff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
